import { render } from "./dashboard.vue?vue&type=template&id=3301b1f1&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=3301b1f1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3301b1f1"

export default script